import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import * as schema from './button.schema';
import { IconComponent } from '../icon';
import { kebabCase } from 'lodash';
import * as h from './button.helpers';

@Component({
    standalone: true,
    selector: 'pt-ui-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [CommonModule, IconComponent]
})
export class ButtonComponent implements OnInit, schema.Element {
    @Input() public disabled: schema.Element['disabled'] = false;
    @Input() public loading: schema.Element['loading'] = false;
    @Input() public label: schema.Element['label'] = '';
    @Input() public icon: schema.Element['icon'] = '';
    @Input() public importance: schema.Element['importance'] = 'secondary';
    @Input() public strict: schema.Element['strict'];
    @Input() public href: schema.Element['href'] = undefined;
    @Input() public submit: schema.Element['submit'] = undefined;
    @Input() public size: 's' | 'm' = 'm';

    public styling = {
        wrapper: () => ({
            wrapper: true,
            'wrapper--primary': this.importance === 'primary',
            'wrapper--loading': this.loading,
            'wrapper--circle': !this.label && Boolean(this.icon),
            'wrapper--disabled': this.disabled || this.loading,
            'wrapper--opacity': this.disabled && !this.loading,
            'wrapper--small': this.size === 's'
        })
    };

    public content = {
        label: () => h.truncate({ value: this.label, amount: 40 })
    };

    public getTestId() {
        return `button-${kebabCase(this.label || this.icon)}`;
    }

    public ngOnInit() {
        if (this.strict !== false && this.label.length > 20) {
            // eslint-disable-next-line no-console
            console.warn('Button label is too long, it will break the layout');
        }
    }
}
